import { render, staticRenderFns } from "./InterestFilter.vue?vue&type=template&id=353031d2&"
import script from "./InterestFilter.vue?vue&type=script&lang=js&"
export * from "./InterestFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports